import { DashboardAsset, DashboardMetrics } from '../../../types/Dashboard'
import { DashboardMap } from './DashboardMap'
import { MetricsOverlay } from './MetricsOverlay'
import { AssetDetailPanel } from './AssetDetailPanel'
import './Dashboard.scss'

type DashboardViewProps = {
    assets: DashboardAsset[]
    metrics: DashboardMetrics
    selectedAsset: DashboardAsset | null
    onSelectAsset: (id: number) => void
    onClearSelection: () => void
}

export function DashboardView({ assets, metrics, selectedAsset, onSelectAsset, onClearSelection }: DashboardViewProps) {
    return (
        <div className="dashboard-container">
            <DashboardMap assets={assets} onSelectAsset={onSelectAsset} />
            <MetricsOverlay metrics={metrics} />
            {selectedAsset && (
                <AssetDetailPanel asset={selectedAsset} onClose={onClearSelection} />
            )}
        </div>
    )
}
